// extracted by mini-css-extract-plugin
export default {"contributePanelOption":"CodeAndDocumentation-module--contributePanelOption--e7d46","contributePanelOptionText":"CodeAndDocumentation-module--contributePanelOptionText--4d199"};